import React, { useState } from 'react'
import { Button, Row, Table } from 'antd'
import { useRecoilState } from 'recoil'
import { userState } from '../../store/user'

const ExcelUploadBodyComponent = ({
  uploadExcelName,
  uploadExcelDataError,
  handleExcelUpload,
  validation,
  readExcelData,
  handleExcelReUpload,
  loading,
}) => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)
  const columns = [
    {
      title: '주문번호',
      width: 90,
      dataIndex: 'orderId',
      key: 'orderId',
      ellipsis: true,
      align: 'center',
    }, // {
    //     title: '세부상품 주문번호',
    //     width: 120,
    //     dataIndex: 'order_detail_id',
    //     key: 'order_detail_id',
    //     align: "center",
    // },
    {
      title: '실패 사유',
      dataIndex: 'error',
      key: 'error',
      align: 'center',
    },
  ]

  return (
    <div className={`excel-body`}>
      {!uploadExcelDataError?.length ? (
        <>
          <b>엑셀 파일을 업로드 하세요</b>
          <div className={`excel-file-upload-div`}>
            <div className={`excel-file-upload-each`}>
              <p className={`upload-title`}>파일 업로드</p>
            </div>
            <div className={`excel-file-upload-each`}>
              <div className={`upload-input`}>
                {uploadExcelName?.length ? uploadExcelName : '선택된 파일 없음'}
              </div>
              <Button
                className={`excel-file-select-btn`}
                onClick={() => {
                  let excelInput = document.getElementById('excelFile')
                  if (excelInput) {
                    excelInput.click()
                  }
                }}
              >
                파일 선택
              </Button>
              <Button
                className={`excel-file-upload-btn`}
                onClick={handleExcelUpload}
                loading={loading}
              >
                등록하기
              </Button>
            </div>
          </div>
          <input
            style={{ display: 'none' }}
            disabled={validation}
            type={'file'}
            id="excelFile"
            onChange={readExcelData}
          />
          <>
            <p className={`excel-description`}>
              * 다운로드 받은 엑셀 파일에서 발송처리 할 데이터 작성 후 등록해
              주세요.
            </p>
            <p className={`excel-description`}>
              * 필수정보(상품주문번호, 개별상품주문번호, 택배사, 송장번호)가
              제대로 입력되었는지 확인해주세요.
            </p>
            <p className={`excel-description`}>
              * 파일 형식은 XLSX 로 올려주세요.
            </p>
            <p className={`excel-description`}>
              * 배송정보가 기재된 엑셀파일 선택 후 ‘등록하기’를 눌러 배송처리를
              완료하세요.
            </p>
            <Button
              className="excel-template-download"
              href={`${process.env.REACT_APP_HOST}/assets/files/TrackingNumber_Template.xlsx`}
            >
              <p className={`excel-description`}>
                엑셀 일괄 발송처리 양식 다운로드
              </p>
            </Button>
          </>
        </>
      ) : (
        <>
          <p className={`excel-description`}>
            * 1행, 2행은 삭제하시면 안됩니다.
          </p>
          <p className={`excel-description`}>
            * 행의 값이 비어있거나 올바른 형식이 아닙니다.
          </p>
          {user?.id === 4 && (
            <p className={`excel-description`}>
              * 같은 주문번호 내 동일한 택배사 및 송장번호 데이터를 작성해
              주세요.
            </p>
          )}
          <p className={`excel-description`}>* 확인 후 다시 업로드해주세요.</p>
          <Table
            className={`commission-table`}
            columns={columns}
            dataSource={uploadExcelDataError}
            loading={isLoading}
            bordered
            size="small"
            rowKey="month"
            rowClassName="coupon-table-row"
            scroll={{ y: 250 }}
            pagination={false}
          />
          <Row
            align={`middle`}
            justify={`space-between`}
            style={{
              marginTop: '1em',
            }}
          >
            {user?.id !== 4 && (
              <Button
                className="excel-template-download"
                href={`${process.env.REACT_APP_HOST}/assets/files/TrackingNumber_Template.xlsx`}
                style={{ marginTop: 0 }}
              >
                <p className={`excel-description`}>
                  엑셀 일괄 발송처리 양식 다운로드
                </p>
              </Button>
            )}
            <Button
              className={`excel-file-upload-btn`}
              onClick={handleExcelReUpload}
              style={{
                marginLeft: 'auto',
              }}
            >
              다시 등록하기
            </Button>
          </Row>
        </>
      )}
    </div>
  )
}
export default ExcelUploadBodyComponent
